export type ScopeModel = {
	checkedRead: boolean
	checkedWrite: boolean
	read: string
	write: string
}

const allScopes: [string, ScopeModel][] = [
	["Application", {checkedRead: true, checkedWrite: true, read: "applications", write: "applications-write"}],
	["Customers", {checkedRead: true, checkedWrite: false, read: "customers", write: "customers-write"}],
	["Customer Tags", {checkedRead: false, checkedWrite: true, read: "", write: "customer-tags-write"}],
	["Customer Token", {checkedRead: false, checkedWrite: true, read: "", write: "customer-token-write"}],
	["Accounts", {checkedRead: true, checkedWrite: true, read: "accounts", write: "accounts-write"}],
	["Account Holds", {checkedRead: false, checkedWrite: false, read: "account-holds", write: "account-holds-write"}],
	["Cards", {checkedRead: true, checkedWrite: false, read: "cards", write: "cards-write"}],
	[
		"Cards Sensitive",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "cards-sensitive",
			write: "cards-sensitive-write",
		},
	],
	[
		"Transactions",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "transactions",
			write: "transactions-write",
		},
	],
	["Authorizations", {checkedRead: true, checkedWrite: false, read: "authorizations", write: ""}],
	["Statements", {checkedRead: true, checkedWrite: false, read: "statements", write: ""}],
	["Payments", {checkedRead: true, checkedWrite: false, read: "payments", write: "payments-write"}],
	[
		"Payments Counterparties",
		{
			checkedRead: false,
			checkedWrite: true,
			read: "",
			write: "payments-write-counterparty",
		},
	],
	[
		"Payments Linked Accounts",
		{
			checkedRead: false,
			checkedWrite: true,
			read: "",
			write: "payments-write-linked-account",
		},
	],
	["Payments ACH", {checkedRead: false, checkedWrite: true, read: "", write: "ach-payments-write"}],
	["Payments Wire", {checkedRead: false, checkedWrite: true, read: "", write: "wire-payments-write"}],
	[
		"Bills",
		{
			checkedRead: false,
			checkedWrite: false,
			read: "billpay-bills",
			write: "billpay-bills-write",
		},
	],
	[
		"Vendors",
		{
			checkedRead: false,
			checkedWrite: false,
			read: "billpay-vendors",
			write: "billpay-vendors-write",
		},
	],
	[
		"Bill Pay Linked Accounts",
		{
			checkedRead: false,
			checkedWrite: false,
			read: "billpay-linked-accounts",
			write: "billpay-linked-accounts-write",
		},
	],
	["Repayments", {checkedRead: true, checkedWrite: false, read: "repayments", write: "repayments-write"}],
	[
		"Payments ACH Debit",
		{
			checkedRead: false,
			checkedWrite: true,
			read: "",
			write: "payments-write-ach-debit",
		},
	],
	[
		"Counterparties",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "counterparties",
			write: "counterparties-write",
		},
	],
	[
		"Batch Releases",
		{
			checkedRead: true,
			checkedWrite: true,
			read: "batch-releases",
			write: "batch-releases-write",
		},
	],
	[
		"Linked Accounts",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "linked-accounts",
			write: "linked-accounts-write",
		},
	],
	["Webhooks", {checkedRead: true, checkedWrite: true, read: "webhooks", write: "webhooks-write"}],
	["Events", {checkedRead: true, checkedWrite: true, read: "events", write: "events-write"}],
	[
		"Authorization Requests",
		{
			checkedRead: true,
			checkedWrite: true,
			read: "authorization-requests",
			write: "authorization-requests-write",
		},
	],
	[
		"Cash Deposits",
		{
			checkedRead: true,
			checkedWrite: true,
			read: "cash-deposits",
			write: "cash-deposits-write",
		},
	],
	[
		"Check Deposits",
		{
			checkedRead: true,
			checkedWrite: true,
			read: "check-deposits",
			write: "check-deposits-write",
		},
	],
	[
		"Received Payments",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "received-payments",
			write: "received-payments-write",
		},
	],
	["Disputes", {checkedRead: true, checkedWrite: false, read: "disputes", write: ""}],
	["Chargebacks", {checkedRead: true, checkedWrite: false, read: "chargebacks", write: "chargebacks-write"}],
	["Rewards", {checkedRead: true, checkedWrite: false, read: "rewards", write: "rewards-write"}],
	[
		"Check Payments",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "check-payments",
			write: "check-payments-write",
		},
	],
	[
		"Credit Decisions",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "credit-decisions",
			write: "credit-decisions-write",
		},
	],
	[
		"Lending Program",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "lending-programs",
			write: "lending-programs-write",
		},
	],
	[
		"Card Fraud Case",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "card-fraud-cases",
			write: "card-fraud-cases-write",
		},
	],
	[
		"Credit Application",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "credit-applications",
			write: "credit-applications-write",
		},
	],
	[
		"Migrations",
		{
			checkedRead: false,
			checkedWrite: false,
			read: "migrations",
			write: "migrations-write",
		},
	],
	[
		"Tax Profiles",
		{
			checkedRead: true,
			checkedWrite: true,
			read: "tax",
			write: "tax-write",
		},
	],
	[
		"Forms",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "forms",
			write: "forms-write",
		},
	],
	[
		"Forms Sensitive",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "forms-sensitive",
			write: "",
		},
	],
	[
		"Wire Drawdowns",
		{
			checkedRead: true,
			checkedWrite: false,
			read: "wire-drawdowns",
			write: "wire-drawdowns-write",
		},
	],
	[
		"Intents",
		{
			checkedRead: false,
			checkedWrite: false,
			read: "intents",
			write: "intents-write",
		},
	],
]

const bankScopesExcluded = new Set(["Cards Sensitive", "Forms", "Forms Sensitive", "Wire Drawdowns"])

const bankScopes: [string, ScopeModel][] = allScopes
	.filter(([name, scope]) => scope.read !== "" && !bankScopesExcluded.has(name))
	.map(([name, scope]) => [
		name,
		{
			checkedRead: scope.checkedRead,
			checkedWrite: false,
			read: scope.read,
			write: "",
		},
	])

export const getPresetScopes = (isPartnerUser: boolean, isBankUser: boolean): Map<string, ScopeModel> => {
	if (isPartnerUser) {
		return new Map()
	}
	return new Map(isBankUser ? bankScopes : allScopes)
}

export const getApiTokenDescription = (isPartnerUser: boolean, isUnitUser: boolean, isBankUser: boolean): string => {
	if (isPartnerUser) {
		return "Use your Partner API Token to create onBehalf token"
	}
	if (isUnitUser) {
		return "Use your Admin API Tokens to authenticate incoming requests"
	}
	if (isBankUser) {
		return "Use your Bank API Tokens to authenticate incoming requests"
	}
	return "Use your Org API Tokens to authenticate incoming requests"
}
